import {
  AGRUPADOR_PAGAMENTO_CREATE,
  AGRUPADOR_PAGAMENTO_UPDATE,
  AGRUPADOR_PAGAMENTO_LOAD,
  AGRUPADOR_PAGAMENTO_DELETE
} from "../actions/agrupadorPagamento";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = {};
const getters = {};

const actions = {
  [AGRUPADOR_PAGAMENTO_CREATE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.agrupadorPagamento
        .create(getters.getFornecedorId, payload)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [AGRUPADOR_PAGAMENTO_UPDATE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.agrupadorPagamento
        .update(getters.getFornecedorId, payload.idagrupadorformapagto, payload)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [AGRUPADOR_PAGAMENTO_LOAD]: ({ dispatch, getters }, idagrupador) => {
    return new Promise((resolve, reject) => {
      Api.v4.agrupadorPagamento
        .get(getters.getFornecedorId, idagrupador)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [AGRUPADOR_PAGAMENTO_DELETE]: ({ dispatch, getters }, idagrupador) => {
    return new Promise((resolve, reject) => {
      Api.v4.agrupadorPagamento
        .remove(getters.getFornecedorId, idagrupador)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
